function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 1a6 6 0 110 12A6 6 0 017 1zm0 2.4a.6.6 0 00-.6.6v3a.6.6 0 00.176.424l1.8 1.8a.6.6 0 00.848-.848L7.6 6.752V4a.6.6 0 00-.6-.6z",
  fill: "currentColor"
});

var SvgPending = function SvgPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgPending;